/* eslint-disable no-console */
const saveToSession = (key, data) => {
  const { sessionStorage } = window;
  sessionStorage.setItem(key, data);
};

const retreiveFromSession = (key) => {
  const { sessionStorage } = window;
  sessionStorage.getItem(key);
};

export {
  retreiveFromSession,
  saveToSession,
};
/* eslint-disable no-console */
